import locales, { DEFAULT_LOCALE } from "/constants/locales"

const str = {
  _currentLocale: DEFAULT_LOCALE,
  ...locales.en.strings,

  set locale(locale) {
    if (this._currentLocale === locale || !locales[locale]) {
      return
    }
    this._currentLocale = locale
    Object.defineProperties(this, Object.fromEntries(Object.entries(locales[this._currentLocale].strings).map(([key, value]) => {
      return [
        key,
        {
          value: value,
          writable: false
        }
      ]
    })))
  },
  get locale() {
    return this._currentLocale
  }
}

export default str
